<template>
<w-settings-content-template>
  <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab" @tab-click="onChangeMenu">
    <el-tab-pane label="벤더 OID 사전" name="WVendorOidDictionaryView" class="h100 w100">
      <w-vendor-oid-dictionary-view :activeTab="activeTab"/>
    </el-tab-pane>
    <el-tab-pane label="모델 OID 사전" name="WModelOidDictionaryView" class="h100 w100">
      <w-model-oid-dictionary-view :activeTab="activeTab"/>
    </el-tab-pane>
    <el-tab-pane label="모델 OID 적용" name="WModelOidSettingView" class="h100 w100">
      <w-model-oid-setting-view :activeTab="activeTab"/>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WVendorOidDictionaryView from './component/VendorOidDictionaryView';
import WModelOidDictionaryView from './component/ModelOidDictionaryView';
import WModelOidSettingView from './component/ModelOidSettingView/index';

export default {
  name: 'WVendorModelOidSettings',
  components: {
    WSettingsContentTemplate,
    WVendorOidDictionaryView,
    WModelOidDictionaryView,
    WModelOidSettingView,
  },
  data() {
    return {
      activeTab: 'WVendorOidDictionaryView',
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeTab = menu.name;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/VendorModelOidSettings/index.vue